import React, { Component } from 'react';
import { Button, Card, CardHeader, CardBody, CardFooter, Col, Container, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon, InputGroupText, Row, NavLink } from 'reactstrap';

import CRNote from '../../Common/crNote'
import PageHead from '../../Common/pageHead'
import Menu from '../../Common/menu'

import Api from '../../../api'

class List extends Component {
  constructor(props) {
    super(props)
    this.state = {
      caregivers: []
    }

    new Api().listCaregiver((succ, ret) => {
      if(succ) {
        this.setState({caregivers: ret})
      }
    })
  }

  logout() {
    var api = new Api()
    api.unmount()
    api.jump('/')
  }

  delete(id) {
    var api = new Api()
    api.removeCaregiver(id, (succ, ret) => {
      console.log(succ)
      console.log(ret)
      if(succ) {
        api.listCaregiver((succ, ret) => {
          if(succ) {
            this.setState({caregivers: ret})
          }
        })
      }
    })
  }

  render() {
    const content = this.state.caregivers.map((caregiver, i) =>
      <tr key={i}>
      <td>{caregiver["first_name"]}</td>
      <td>{caregiver["last_name"]}</td>
      <td>{caregiver["email"]}</td>
      <td>{caregiver["phone"]}</td>
      <td>{caregiver["sms"]}</td>
      <td>
      <NavLink className="inline-link" href={'/setting/' + i}>
        <Button className="" style={{minWidth: "0px"}}>Edit</Button>
      </NavLink>
      <Button className="" style={{minWidth: "0px"}} onClick={this.delete.bind(this, caregiver["id"])}>Delete</Button>
      </td></tr>
    )

    return (

      <div className="app align-items-center mcg">

        <span className="frontbk" style={{zIndex:"0"}} />

        <Container style={{zIndex:"1"}}>
          <PageHead/>
        </Container>

        <Container style={{zIndex:"2"}}>
          <Row className="justify-content-center">
            <Card className="mb-0">
            <Menu/>
              <CardHeader className="titlehead">
                  <h1 className="mb-0 my-2">My Contacts</h1>
                  <p className="text-center mb-0"></p>
              </CardHeader>
              <CardBody className="pageSetting login-form py-0">
                
                <Row>
                  <Col lg="12" className="leftbox pt-0">
                    <Row className="subheader">
                      {this.state.caregivers.length < 5 && <Col sm="4" className="text-center">
                        <NavLink className="inline-link" href="/setting">
                          <Button outline  className="px-4 btn-outline" color="primary">New Caregiver</Button>
                        </NavLink>
                      </Col>}
                      {/*
                      <Col sm="4" className="text-center">
                        <NavLink className="inline-link" href="/changepw">
                          <Button outline  className="px-4 btn-outline" color="primary">Change Password</Button>
                        </NavLink>
                      </Col>
                      */}
                      {/*<Col sm="4" className="text-center">*/}
                        {/* <NavLink className="inline-link" href="/login"> */}
                        {/* <Button outline  className="px-4 btn-outline" color="primary" onClick={this.logout.bind(this)}>Log-Out</Button> */}
                        {/* </NavLink> */}
                      {/*</Col>*/}
                    </Row>
                    <div className="rb-inner" style={{ paddingTop: '2rem' }}>
                      
                      <table style={{width:'100%'}}>
                        <tbody>
                          <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>SMS</th>
                            <th>Action</th>
                          </tr>
                          {content}
                        </tbody>
                      </table>
                      <br />
                      {/*
                        <div className="tips-msg pb-0">
                        For International Phone numbers (non U.S) please <NavLink href="#" className="inline-link">Click Here for Examples</NavLink>.<br /> 
                        Example showing UK: change this 07911 123456 to 447911123456
                      </div>
                      */}
                    </div>
                  </Col>
                  {/*
<Col lg="4" className="rightbox termsbox">
                    <div className="font-weight-bold stitle">Your Plan B Features are now active.</div>
                    <ol className="terms pb-4">
                      <li>120 Messages per month.</li>
                      <li>5 Additional Contacts have been added for a total of 10</li>
                      <li>Disable Alert All. This checkbox located at the bottom of the Settings Page, Use this if Alexa misunderstands you and defaults to Alert All. Send Help and Alert Everyone will still work.</li>
                      <li>Multi lingual Alerts: Spanish, French, Swedish, German, Portuguese and Italian. Need more, let us know. These language options can be selected from a drop down list for each contact you have entered on your Contact page.</li>
                    </ol>
                  </Col>
                  */}
                </Row>
              </CardBody>

            </Card>
          </Row>
        </Container>

        <Container style={{zIndex:"3"}}>
          <CRNote/>
        </Container>
      </div>
    );
  }
}

export default List;


// WEBPACK FOOTER //
// ./src/views/Pages/List/List.js